// Contexto de `FiltroSeccion` (filtros-popover.tsx): el id del título de la
// sección, que los `GrupoChips` de adentro usan como `aria-labelledby` cuando
// no reciben uno propio. Vive en un .ts aparte por la regla de Fast Refresh
// (un .tsx exporta solo componentes).
import { createContext } from 'react';

/** Id del título de la `FiltroSeccion` que contiene al grupo; null afuera de una sección. */
export const SeccionContexto = createContext<string | null>(null);
